import type { ReactNode } from 'react'
import { Card } from '~/components/ui/card'
import { cn } from '~/lib/utils'

interface ChartCardProps {
    title: string
    description?: string
    /** 우측 상단 보조 정보(범례 요약·합계 등) */
    aside?: ReactNode
    /** 데이터가 비었을 때 표시할 빈상태 문구. 지정 시 children 대신 렌더. */
    empty?: boolean
    emptyText?: string
    children: ReactNode
    className?: string
}

// 차트 표면 카드. 각진 보더 주도(그림자 최소) + .admin-eyebrow 제목 + 헤더 구분선.
export function ChartCard({
    title,
    description,
    aside,
    empty,
    emptyText = '표시할 데이터가 없어요.',
    children,
    className,
}: ChartCardProps) {
    return (
        <Card className={cn('shadow-none', className)}>
            <div className='border-border flex items-start justify-between gap-4 border-b px-4 py-3'>
                <div>
                    <h3 className='admin-eyebrow'>{title}</h3>
                    {description ? (
                        <p className='text-muted-foreground mt-1 text-[13px]'>
                            {description}
                        </p>
                    ) : null}
                </div>
                {aside ? <div className='shrink-0'>{aside}</div> : null}
            </div>
            <div className='p-4'>
                {empty ? (
                    <div className='border-border text-muted-foreground flex h-40 items-center justify-center rounded-[var(--radius)] border border-dashed text-sm'>
                        {emptyText}
                    </div>
                ) : (
                    children
                )}
            </div>
        </Card>
    )
}
